module.exports = __webpack_public_path__ + "img/chinese-big.dcd6860e.jpg";